// Generated by CoffeeScript 1.12.7
var feedback, scoring;

scoring = require('./scoring');

feedback = {
  default_feedback: {
    warning: '',
    suggestions: [
      {
        code: 'use_a_few_words',
        message: 'Use a few words, avoid common phrases'
      }, {
        code: 'no_need_for_mixed_chars',
        message: 'No need for symbols, digits, or uppercase letters'
      }
    ]
  },
  get_feedback: function(score, sequence) {
    var extra_feedback, i, len, longest_match, match, ref;
    if (sequence.length === 0) {
      return this.default_feedback;
    }
    if (score > 2) {
      return {
        warning: '',
        suggestions: []
      };
    }
    longest_match = sequence[0];
    ref = sequence.slice(1);
    for (i = 0, len = ref.length; i < len; i++) {
      match = ref[i];
      if (match.token.length > longest_match.token.length) {
        longest_match = match;
      }
    }
    feedback = this.get_match_feedback(longest_match, sequence.length === 1);
    extra_feedback = {
      code: 'add_another_word',
      message: 'Add another word or two. Uncommon words are better.'
    };
    if (feedback != null) {
      feedback.suggestions.unshift(extra_feedback);
      if (feedback.warning == null) {
        feedback.warning = '';
      }
    } else {
      feedback = {
        warning: '',
        suggestions: [extra_feedback]
      };
    }
    return feedback;
  },
  get_match_feedback: function(match, is_sole_match) {
    var layout, warning;
    switch (match.pattern) {
      case 'dictionary':
        return this.get_dictionary_match_feedback(match, is_sole_match);
      case 'spatial':
        layout = match.graph.toUpperCase();
        warning = match.turns === 1 ? {
          code: 'straight-rows',
          message: 'Straight rows of keys are easy to guess'
        } : {
          code: 'short-keyboard-patterns',
          message: 'Short keyboard patterns are easy to guess'
        };
        return {
          warning: warning,
          suggestions: [
            {
              code: 'use-longer-keyboard-pattern',
              message: 'Use a longer keyboard pattern with more turns'
            }
          ]
        };
      case 'repeat':
        warning = match.base_token.length === 1 ? {
          code: 'repeats-aaa',
          message: 'Repeats like "aaa" are easy to guess'
        } : {
          code: 'repeats-abcabcabc',
          message: 'Repeats like "abcabcabc" are only slightly harder to guess than "abc"'
        };
        return {
          warning: warning,
          suggestions: [
            {
              code: 'avoid-repeated-words',
              message: 'Avoid repeated words and characters'
            }
          ]
        };
      case 'sequence':
        return {
          warning: {
            code: 'sequences-abc-6543',
            message: 'Sequences like abc or 6543 are easy to guess'
          },
          suggestions: [
            {
              code: 'avoid-sequences',
              message: 'Avoid sequences'
            }
          ]
        };
      case 'regex':
        if (match.regex_name === 'recent_year') {
          return {
            warning: {
              code: 'recent-years',
              message: 'Recent years are easy to guess'
            },
            suggestions: [
              {
                code: 'avoid-recent-years',
                message: 'Avoid recent years'
              }, {
                code: 'avoid-personnal-years',
                message: 'Avoid years that are associated with you'
              }
            ]
          };
        }
        break;
      case 'date':
        return {
          warning: {
            code: 'dates',
            message: 'Dates are often easy to guess'
          },
          suggestions: [
            {
              code: 'avoid-personnal-dates-years',
              message: 'Avoid dates and years that are associated with you'
            }
          ]
        };
    }
  },
  get_dictionary_match_feedback: function(match, is_sole_match) {
    var ref, result, suggestions, warning, word;
    warning = match.dictionary_name === 'passwords' ? is_sole_match && !match.l33t && !match.reversed ? match.rank <= 10 ? {
      code: 'top-10',
      message: 'This is a top-10 common password'
    } : match.rank <= 100 ? {
      code: 'top-100',
      message: 'This is a top-100 common password'
    } : {
      code: 'very-common',
      message: 'This is a very common password'
    } : match.guesses_log10 <= 4 ? {
      code: 'similar-common',
      message: 'This is similar to a commonly used password'
    } : void 0 : match.dictionary_name === 'english_wikipedia' ? is_sole_match ? {
      code: 'word',
      message: 'A word by itself is easy to guess'
    } : void 0 : (ref = match.dictionary_name) === 'surnames' || ref === 'male_names' || ref === 'female_names' ? is_sole_match ? {
      code: 'names-surnames',
      message: 'Names and surnames by themselves are easy to guess'
    } : {
      code: 'common-names-surnames',
      message: 'Common names and surnames are easy to guess'
    } : '';
    suggestions = [];
    word = match.token;
    if (word.match(scoring.START_UPPER)) {
      suggestions.push({
        code: 'capitalization',
        message: "Capitalization doesn't help very much"
      });
    } else if (word.match(scoring.ALL_UPPER) && word.toLowerCase() !== word) {
      suggestions.push({
        code: 'all-uppercase',
        message: 'All-uppercase is almost as easy to guess as all-lowercase'
      });
    }
    if (match.reversed && match.token.length >= 4) {
      suggestions.push({
        code: 'reversed-words',
        message: "Reversed words aren't much harder to guess"
      });
    }
    if (match.l33t) {
      suggestions.push({
        code: 'predictable-substitutions',
        message: "Predictable substitutions like '@' instead of 'a' don't help very much"
      });
    }
    result = {
      warning: warning,
      suggestions: suggestions
    };
    return result;
  }
};

module.exports = feedback;

//# sourceMappingURL=feedback.js.map
